<template>
  <div>
    <v-container class="py-0">
      <transition name="fade" mode="out-in" appear>
        <PageTitle class="d-block d-lg-none">Payment Requests</PageTitle>
      </transition>

      <transition name="slide-left-fade" mode="out-in" appear>
        <v-tabs
          v-model="tab"
          class="mt-5 mt-sm-1"
          color="tabColor"
          slider-color="tabColor"
          center-active
          background-color="tertiary"
          show-arrows
          height="55"
        >
          <v-tab ripple>
            Requested
          </v-tab>
          <v-tab ripple>
            Partially Paid
          </v-tab>
          <v-tab ripple>
            Fully Paid
          </v-tab>
          <v-tab ripple>
            Cancelled
          </v-tab>
          <v-tab ripple>
            STO Setup
          </v-tab>
          <v-tab ripple>
            All
          </v-tab>
          <v-spacer></v-spacer>
          <span class="d-none d-lg-block">
            <PageTitle>Payment Requests</PageTitle>
          </span>
        </v-tabs>
      </transition>

      <transition name="slide-fade" mode="out-in" appear>
        <div>
          <v-tabs-items v-model="tab" class="pt-2 tertiary">
            <v-tab-item>
              <GenericRequestsTable 
                ref="requestedTable"
                :state="'Requested'"
                :message="'payment requests pending'"
                :isLoading="loading.requested"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
            <v-tab-item>
              <GenericRequestsTable 
                ref="partiallyPaidTable"
                :state="'PartiallyPaid'"
                :message="'payment requests partially paid'"
                :isLoading="loading.partiallyPaid"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
            <v-tab-item>
              <GenericRequestsTable 
                ref="fullyPaidTable"
                :state="'FullyPaid'"
                :message="'payment requests fully paid'"
                :isLoading="loading.fullyPaid"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
            <v-tab-item>
              <GenericRequestsTable 
                ref="cancelledTable"
                :state="'Cancelled'"
                :message="'payment requests cancelled'"
                :isLoading="loading.cancelled"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
            <v-tab-item>
              <GenericRequestsTable 
                ref="stoSetupTable"
                :state="'StoSetup'"
                :message="'standing orders set up'"
                :isLoading="loading.stoSetup"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
            <v-tab-item>
              <GenericRequestsTable 
                ref="allTable"
                :state="''"
                :message="'total payment requests'"
                :isLoading="loading.all"
                @refresh="refreshRequestData"
                @showError="showSnackbarError"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </transition>

      <Snackbar 
        :snackbarDialog="snackbar"
        :snackbarText="snackbarText"
        :snackbarColor="snackbarColor"
        @closeSnackbar="closeSnackbar()"
      />
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GenericRequestsTable from '@/components/PaymentRequests/GenericRequestsTable.vue';
import Snackbar from '@/components/Snackbars/TheSnackbar'
import PageTitle from '@/components/Slots/PageTitle.vue'

export default {
  name: 'Payments',
  components: {
    GenericRequestsTable,
    Snackbar,
    PageTitle
  },
  created() {
    // Only load the first tab (Requested) on initial load
    this.loadedTabs.requested = true
  },
  data() {
    return {
      tab: null,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      loadedTabs: {
        requested: false,
        partiallyPaid: false,
        fullyPaid: false,
        cancelled: false,
        stoSetup: false,
        all: false
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.PaymentRequests.loading
    })
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'requested',
        1: 'partiallyPaid',
        2: 'fullyPaid',
        3: 'cancelled',
        4: 'stoSetup',
        5: 'all'
      }
      
      const tabType = tabMap[newTab]
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadedTabs[tabType] = true
      }
    }
  },
  methods: {
    refreshRequestData(msg) {
      this.snackbar = true
      this.snackbarText = msg
      this.snackbarColor = 'green'
      
      // Refresh the current tab's data
      const tabMap = {
        0: 'requestedTable',
        1: 'partiallyPaidTable',
        2: 'fullyPaidTable',
        3: 'cancelledTable',
        4: 'stoSetupTable',
        5: 'allTable'
      }
      
      const currentTableRef = tabMap[this.tab]
      if (currentTableRef && this.$refs[currentTableRef]) {
        this.$refs[currentTableRef].getPaymentRequestDetails()
      }
    },
    showSnackbarError() {
      this.snackbar = true
      this.snackbarText = 'Error whilst creating request. Please try again.'
      this.snackbarColor = 'red'
    },
    closeSnackbar() {
      this.snackbar = false
      this.snackbarText = ''
      this.snackbarColor = ''
    },
  }
}
</script>
    
    <style>
    
    </style>
    